<div class="loader" *ngIf="show" [class.no-fon]="noFon">
  <img class="loader-image" src="assets/images/loader.svg" alt="{{loaderTitle}}" width="{{spinnerSize}}" height="{{spinnerSize}}">
  <span class="text">{{loaderTitle}}</span>
</div>
